import React, { FC, Fragment } from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { Switch } from "../core/Switch";
import { WaterIcon } from "../core/icons/Icons";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { useStyles } from "../../useStyles";
import { InputLabel } from "@material-ui/core";
import { NumberInput } from "../core/NumberField";

export const AdjustableLoadElectricBoilerForm: FC = () => {
    const classes = useStyles();
    const { values, setValues, getFieldProps } = useFormModel<
        ChangeNames.ADJUSTABLE_LOAD_ELECTRICAL_BOILER
    >();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<WaterIcon />}
                content={
                    <p className={classes.label}>
                        Elektrische Warmwasseraufbereitung (Durchlauferhitzer)
                    </p>
                }
                useSwitch={
                    <Switch
                        checked={values.adjustableLoadElectricBoiler.value.installed}
                        {...getFieldProps("adjustableLoadElectricBoiler.value.installed")}
                        onChange={(e, checked) =>
                            setValues(values => {
                                values.adjustableLoadElectricBoiler.value.installed = checked;
                                values.adjustableLoadElectricBoiler.value.demand.amount = checked
                                    ? 0
                                    : null;
                            })
                        }
                    />
                }
                detailCondition={values.adjustableLoadElectricBoiler.value.installed}
                detail={
                    <Fragment>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Summe der Leistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            fixedDecimalScale={false}
                            allowLeadingZeros={false}
                            decimalScale={values.adjustableLoadElectricBoiler.value.demand.precision}
                            isNumericString={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.adjustableLoadElectricBoiler.value.demand.unit}
                            value={values.adjustableLoadElectricBoiler.value.demand.amount || ""}
                            placeholder="0"
                            onValueChange={v =>
                                setValues(values => {
                                    values.adjustableLoadElectricBoiler.value.demand.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.adjustableLoadElectricBoiler.error != null}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
